import axios from 'axios';
import { API_BASE_URL } from '../../src/config';
import { setAdminSessionNotice, resolveAdminSessionEndReason } from '../../src/utils/adminSessionNotice';

const client = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});

const getAdminToken = () => localStorage.getItem('adminToken');

const token = getAdminToken();
if (token) {
  client.defaults.headers.common.Authorization = `Bearer ${token}`;
}

client.interceptors.request.use((config) => {
  const nextConfig = { ...config };
  nextConfig.headers = nextConfig.headers ?? {};

  const latestToken = getAdminToken();
  if (latestToken) {
    nextConfig.headers.Authorization = `Bearer ${latestToken}`;
  } else if (nextConfig.headers.Authorization) {
    delete nextConfig.headers.Authorization;
  }

  return nextConfig;
});

let hasHandledAdminSessionEnd = false;

const isAdminApiRequest = (requestUrl = '') => /\/api\/admin\//i.test(String(requestUrl));

const isAdminAuthRequest = (requestUrl = '') => /\/api\/admin\/auth\//i.test(String(requestUrl));

client.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = Number(error?.response?.status);
    const requestUrl = String(error?.config?.url ?? '');
    const isSessionError = status === 401;
    const hasAdminSession = Boolean(localStorage.getItem('adminToken'));
    const onAdminLoginRoute = typeof window !== 'undefined' && /^\/admin\/(login|forgot-password|reset-password)/i.test(window.location?.pathname || '');

    if (
      !hasHandledAdminSessionEnd
      && isSessionError
      && hasAdminSession
      && isAdminApiRequest(requestUrl)
      && !isAdminAuthRequest(requestUrl)
      && !onAdminLoginRoute
    ) {
      hasHandledAdminSessionEnd = true;
      const backendMessage = String(error?.response?.data?.message ?? '');
      const reason = resolveAdminSessionEndReason(backendMessage);
      setAdminSessionNotice({ reason, backendMessage });

      localStorage.removeItem('adminToken');
      localStorage.removeItem('adminUser');
      delete client.defaults.headers.common.Authorization;

      if (typeof window !== 'undefined') {
        window.location.assign('/admin/login');
      }
    }

    return Promise.reject(error);
  },
);

export default client;
